<template>
  <div class="page-Title">
    <div class="col-6 d-flex">
      <b style="font-size: 22px">{{ pageName }}</b>
      <div v-if="browsing" class="browsing">閲覧制限有</div>
    </div>

    <div
      class="col-6"
      style="display: flex; justify-content: flex-end; font-size: 14px"
    >
      {{ pageContent }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    pageName: String,
    pageContent: String,
    browsing: Boolean
  }
}
</script>

<style scoped lang="scss">
.page-Title {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 30px;
  background-color: rgb(50, 102, 222);
  font-size: 22px !important;
  color: white;
}
.browsing {
  background: rgb(242, 246, 255);
  color: rgb(210, 45, 0);
  font-size: 12px;
  padding: 2px 5px;
  margin-left: 2rem;
}
</style>
